<template>
  <a-collapse v-model:activeKey="activeKey" ghost>
    <a-collapse-panel key="1" header="示例">
      <div
        class="-mt-7 mb-5 w-[310px] ml-1 rounded-lg h-[381px] dashed bg-[#FA683A]/[0.1] pt-2.5"
      >
        <div class="flex h-[172px] ml-[68px]">
          <div class="bg-[#D25B43] rounded-l-[86px]">
            <div
              class="w-[86px] h-[172px] relative rounded-l-[86px] border border-[#FA683A]/[0.1] border-r-0 bg-black-50/[0.8]"
            ></div>
          </div>
          <div
            class="w-[86px] h-[172px] relative mix-blend-normal rounded-r-[86px] bg-[#D25B43]"
          >
            <div
              class="w-[52px] h-[104px] mt-[34px] bg-black-50/[0.8] rounded-r-[52px] absolute"
            >
              <!-- 半径R交互 -->
              <div
                v-if="clickAttr === '1-r'"
                class="w-[52px] border-b border-b-white border-dashed absolute font-normal text-[12px] bottom-[52px]"
              >
                R 60%
              </div>
              <div class="bottom-0 -ml-[6px] absolute">
                <Icon
                  icon="progressBarPolygon.svg"
                  :width="12"
                  :height="12"
                  fill="none"
                />
              </div>
            </div>
            <!-- 端点交互 -->
            <div
              v-if="clickAttr === '2-端点'"
              class="h-[34px] absolute border-r border-b-white border-dashed"
            ></div>
            <div
              v-if="clickAttr === '2-端点'"
              class="h-[34px] absolute border-r border-b-white border-dashed bottom-0"
            ></div>
            <!-- 起始角度交互 -->
            <div v-if="clickAttr === '3-0'" class="angle relative">
              <div class="absolute -bottom-2 text-[12px] left-1">0°</div>
            </div>
            <!-- 结束角度交互 -->
            <div v-if="clickAttr === '4-180'" class="angle top-[86px]">
              <div class="absolute -top-2 text-[12px] left-1">180°</div>
            </div>
            <!-- 指示器半径交互 -->
            <div
              v-if="clickAttr === '5-56%'"
              class="h-[43px] w-[86px] absolute border-l border-l-white border-dashed top-[86px]"
            >
              <span class="ml-1 absolute -top-2">56%</span>
            </div>
          </div>
        </div>

        <div class="mx-4 mt-2.5">
          <div class="flex gap-2 mt-2.5 flex-wrap">
            <div
              v-for="(value, key, index) in list"
              :key="index"
              :class="value[0] === '指示器半径' ? 'w-[278px]' : 'w-[135px]'"
              @mouseover="Attrdisplay(key)"
            >
              <AttrBase
                :label="value[0]"
                class="border border-[#FA683A]/[0.1] hover:bg-[#E66138]/[0.3] hover:border-[#E66138] bg-progress text-[#E66138]"
              >
                <span style="font-size: 14px; opacity: 0.7; color: #e66138">
                  {{ value[1] }}
                </span>
              </AttrBase>
            </div>
          </div>
        </div>
      </div>
    </a-collapse-panel>
  </a-collapse>
</template>
<script lang="ts" setup>
import { ref, reactive } from 'vue';
const activeKey = ref([]);
let clickAttr = ref('');
const list = reactive({
  '1-r': ['半径R', '60%'],
  '2-端点': ['端点', '平角'],
  '3-0': ['起始角度', '0'],
  '4-180': ['结束角度', '180'],
  '5-56%': ['指示器半径', '56%']
});
function Attrdisplay(attr: string): void {
  clickAttr.value = attr;
}
</script>

<style scoped>
* {
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  color: #ffffff;
}

.angle {
  @apply h-[86px] w-[86px] absolute border-l border-l-white border-dashed;
}

:deep(.ant-collapse-header.ant-collapse-header) {
  background-color: transparent !important;
  margin-bottom: 10px;
  font-size: 14px;
  opacity: 0.7;
  padding: 12px 10px !important;
}

:deep(.ant-collapse-content-box.ant-collapse-content-box) {
  padding: 0;
}

.dashed {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23FA683A88' stroke-width='1' stroke-dasharray='12%2c 12' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-progress {
  background-color: rgb(230 97 56 / 0.1);
}
</style>
<style scoped lang="less">
:deep(.anticon.anticon-right.ant-collapse-arrow) {
  position: absolute;
  right: 5px;
  bottom: 15px;
  svg {
    width: 14px;
    height: 14px;
  }
}
</style>
